// Copyright 2026 - Hewlett Packard Enterprise Company
import React from 'react';

// Shared AuthContext - can be used by AuthProviders
// This ensures components can use the same context regardless of which provider is active

// eslint-disable-next-line react-refresh/only-export-components
export const AuthContext = React.createContext({});
export const AuthConsumer = AuthContext.Consumer;
